/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Tracks paths of visited nodes. Uses the "last visited node" approach.
 * This might not be perfectly accurate, since we don't actually know if
 * the last visited node is the one where the edge comes from.
 * However, it should work well enough in most cases.
 */
export class VisitTracker {
    #visited = new Map();
    constructor(visits = []) {
        this.#visited = new Map(visits);
    }
    visit(node, path) {
        this.#visited.set(node, path);
    }
    pathFor(node) {
        return this.#visited.get(node);
    }
    visited() {
        return Array.from(this.#visited.entries());
    }
}
//# sourceMappingURL=visit-tracker.js.map